var exports = {
  "iE": "xa15a2ab7--1a8622--wrapper",
  "Kk": "xa15a2ab7--1a8622--icon",
  "DD": "xa15a2ab7--1a8622--title",
  "iU": "xa15a2ab7--1a8622--message",
};

module.exports = exports;
